import filterDropdown from "./components/filter-dropdown";
import "./components/jump-link";
import NavigationMenu from "./components/navigation-desktop"

filterDropdown();

// setup the desktop navigation
NavigationMenu();
